import { render, staticRenderFns } from "./InstitutionAdd.vue?vue&type=template&id=d460ecda&"
import script from "./InstitutionAdd.vue?vue&type=script&lang=js&"
export * from "./InstitutionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports